import { graphql } from '@/gql';
import { mutationExecute } from '@/Utils/graphqlAPI';

export const handlePaymentIntentErrorForGiftCards = async ({ userId, paymentIntentId }: { userId: string; paymentIntentId: string }) => {
  const response = await mutationExecute({
    variables: {
      userId,
      paymentIntentId,
    },
    mutation: graphql(`
      mutation handlePaymentIntentErrorForGiftCards($userId: String!, $paymentIntentId: String!) {
        handlePaymentIntentErrorForGiftCards(userId: $userId, paymentIntentId: $paymentIntentId)
      }
    `),
  });

  return response.data?.handlePaymentIntentErrorForGiftCards ?? false;
};
